import { useTranslation } from 'react-i18next';

const NoPermission = () => {
  const { t } = useTranslation('Vindoc');

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <h1>{t('403')}</h1>
      <h2>{t('Forbidden')}</h2>
      <p>{t(`You don't have permission to access this page.`)}</p>
    </div>
  );
};

export default NoPermission;
